/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { FormControl, FormControlLabel, RadioGroup, Radio, Typography } from '@mui/material';
import { CustomStack } from 'modules/common/components';
import BookingDatePicker from 'modules/dashboard/components/tab-container/inner-filter/components/booking-date-picker';
import styles from 'modules/dashboard/components/tab-container/inner-filter/inner-filter.module.scss';
/**
 * Booking window component common for the dashboard component
 * @param {Boolean} vOTB - State to enable custom booking
 * @param {Boolean} customBooking - State to enable custom booking
 * @param {Boolean} handleOTBChange - Function to call when the radio button selection changes
 * @param {Function} reportType - Report type
 * @param {Date} latestDate - Latest date value
 * @param {*} otbValue - OTB value
 * @returns
 */
const BookingWindow = ({
  vOTB,
  customBooking,
  handleOTBChange,
  reportType,
  latestDate,
  otbValue,
  id = '',
}) => (
  <CustomStack cssClassName={styles.innerFilter} >
    <div className='booking-date-range'>
    <FormControl >
      <Typography sx={{ color: '#0009' }}>Booking Window</Typography>
      <RadioGroup value={vOTB} name="radio-buttons-group" onChange={handleOTBChange}>
        <FormControlLabel
          sx={{
            my: -1,
          }}
          value={otbValue}
          control={<Radio id={`${id}-otb`} />}
          label="OTB"
        />
        <FormControlLabel
          sx={{
            my: -1,
          }}
          value
          control={<Radio id={`${id}-custom-booking-window`} />}
          label="Custom Booking Window"
        />
      </RadioGroup>
    </FormControl>
       </div>
    {customBooking && (
      <BookingDatePicker reportType={reportType} latestDate={latestDate} id={`${id}-date-picker`} />
    )}
  </CustomStack>
);
//
export default BookingWindow;
